import React, { useEffect } from 'react';
import MainLayout from '../components/layout/MainLayout';

const pricingCSS = `
*{box-sizing:border-box}
body{background:#0d1117 !important}
.pricing-wrap{font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;color:#e6edf3;background:#0d1117;min-height:100vh}
.pricing-wrap a{color:#818cf8;text-decoration:none}
.hero{text-align:center;padding:60px 20px 40px}
.hero h1{font-size:clamp(2rem,5vw,3rem);font-weight:800;background:linear-gradient(135deg,#818cf8,#c084fc,#f472b6);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;margin-bottom:16px}
.hero p{font-size:1.15rem;color:#8b949e;max-width:640px;margin:0 auto;line-height:1.6}
.plans{display:grid;grid-template-columns:repeat(4,1fr);gap:16px;max-width:1400px;margin:40px auto 60px;padding:0 20px}
@media(max-width:1100px){.plans{grid-template-columns:repeat(2,1fr)}}
@media(max-width:600px){.plans{grid-template-columns:1fr}}
.plan{background:rgba(255,255,255,0.03);border:1px solid rgba(255,255,255,0.08);border-radius:20px;padding:32px 24px;display:flex;flex-direction:column;transition:border-color .2s,transform .2s}
.plan:hover{border-color:rgba(129,140,248,0.3);transform:translateY(-4px)}
.plan.pop{border-color:rgba(129,140,248,0.4);background:rgba(129,140,248,0.05);position:relative}
.plan.pop::before{content:'Most Popular';position:absolute;top:-12px;left:50%;transform:translateX(-50%);background:linear-gradient(135deg,#818cf8,#6366f1);color:#fff;font-size:11px;font-weight:700;padding:4px 14px;border-radius:20px}
.pn{font-size:1.05rem;font-weight:700;margin-bottom:4px;color:#e6edf3}
.pd{font-size:12.5px;color:#8b949e;margin-bottom:16px;line-height:1.4;min-height:36px}
.pp{font-size:2.4rem;font-weight:800;margin-bottom:2px;color:#fff}
.pp span{font-size:13px;font-weight:400;color:#8b949e}
.py{font-size:12px;color:#8b949e;margin-bottom:20px}
.pp span{font-size:13px;font-weight:400;color:#8b949e}
.py{font-size:12px;color:#8b949e;margin-bottom:20px}
.pb{display:block;text-align:center;padding:12px;border-radius:12px;font-size:14px;font-weight:700;cursor:pointer;border:none;transition:all .2s;margin-bottom:24px;text-decoration:none}
.b0{background:rgba(255,255,255,0.06);color:#e6edf3;border:1px solid rgba(255,255,255,0.15)}
.b1{background:linear-gradient(135deg,#818cf8,#6366f1);color:#fff}
.b2{background:transparent;color:#818cf8;border:2px solid #818cf8}
.b3{background:linear-gradient(135deg,#f59e0b,#d97706);color:#fff}
.ft{list-style:none;display:flex;flex-direction:column;gap:8px;flex:1;padding:0;margin:0}
.ft li{font-size:12.5px;color:#c9d1d9;display:flex;align-items:flex-start;gap:7px;line-height:1.35}
.ft li::before{content:'✓';color:#10b981;font-weight:700;flex-shrink:0}
.ft .s{font-size:10px;font-weight:700;color:#8b949e;text-transform:uppercase;letter-spacing:.8px;margin-top:10px;padding-top:10px;border-top:1px solid rgba(255,255,255,0.05)}
.ft .s::before{content:'';display:none}
.ft .x{color:#484f58}
.ft .x::before{content:'—';color:#484f58}
.cmp{max-width:1300px;margin:0 auto 80px;padding:0 20px;overflow-x:auto}
.cmp h2{text-align:center;font-size:1.8rem;font-weight:700;margin-bottom:28px}
.cmp table{width:100%;border-collapse:collapse;font-size:12.5px;min-width:800px}
.cmp th{text-align:left;padding:10px 12px;border-bottom:1px solid rgba(255,255,255,0.08);color:#8b949e;font-weight:600;font-size:12px}
.cmp td{padding:8px 12px;border-bottom:1px solid rgba(255,255,255,0.04);color:#c9d1d9}
.cmp tr:hover td{background:rgba(255,255,255,0.02)}
.cmp .cat{font-weight:700;color:#818cf8;padding-top:14px;font-size:11px;text-transform:uppercase;letter-spacing:.5px}
.ck{color:#10b981;font-weight:700}
.cx{color:#484f58}
.cl{color:#f59e0b;font-size:11px}
.pc{max-width:800px;margin:0 auto 80px;padding:0 20px;text-align:center}
.pc h2{font-size:1.8rem;font-weight:700;margin-bottom:14px}
.pc p{color:#8b949e;font-size:14px;line-height:1.7;margin-bottom:28px}
.cl-logos{display:flex;justify-content:center;gap:20px;flex-wrap:wrap}
.cl-logos span{font-size:13px;color:#c9d1d9;padding:8px 16px;border:1px solid rgba(255,255,255,0.08);border-radius:10px;background:rgba(255,255,255,0.02)}
.faq{max-width:700px;margin:0 auto 80px;padding:0 20px}
.faq h2{text-align:center;font-size:1.8rem;font-weight:700;margin-bottom:28px}
.fi{border-bottom:1px solid rgba(255,255,255,0.06);padding:16px 0}
.fq{font-size:14px;font-weight:600;cursor:pointer;display:flex;justify-content:space-between;align-items:center;background:none;border:none;color:#e6edf3;width:100%;text-align:left}
.fa{font-size:13px;color:#8b949e;line-height:1.7;margin-top:10px;display:none}
.fi.open .fa{display:block}
.fq::after{content:'▾';font-size:16px;color:#484f58;transition:transform .2s}
.fi.open .fq::after{transform:rotate(180deg)}
`;

const PricingPage: React.FC = () => {
  useEffect(() => {
    const style = document.createElement('style');
    style.id = 'pricing-styles';
    style.textContent = pricingCSS;
    document.head.appendChild(style);
    // FAQ toggle
    const items = document.querySelectorAll('.fi');
    items.forEach(i => {
      i.querySelector('.fq')?.addEventListener('click', () => i.classList.toggle('open'));
    });
    return () => { document.getElementById('pricing-styles')?.remove(); };
  }, []);

  return (
    <MainLayout>
      <div className="pricing-wrap">
        <div className="hero">
          <h1>Simple, transparent pricing</h1>
          <p>Start free. Scale when you're ready. Your AI, your data, your cloud — or ours.</p>
        </div>

        <div className="plans">
          <div className="plan">
            <div className="pn">Free</div>
            <div className="pd">Explore the Filiz Family and AI agents</div>
            <div className="pp">$0<span>/mo</span></div>
            <div className="py">Free forever</div>
            <a href="/register" className="pb b0">Get Started</a>
            <ul className="ft">
              <li className="s">AI & Family</li>
              <li>Unlimited Anne/Baba/Expert chat</li>
              <li>AskAI — 10 msg/day</li>
              <li>FlzHub family chat</li>
              <li className="s">Community</li>
              <li>Social feed — 3 posts/day</li>
              <li>Research — read + join</li>
              <li className="s">Agents & Work</li>
              <li>1 agent (basic persona)</li>
              <li>Unlimited tasks</li>
              <li className="s">Storage</li>
              <li>5GB RunAI Cloud</li>
              <li className="x">No Twin</li>
              <li className="x">No document upload</li>
            </ul>
          </div>

          <div className="plan pop">
            <div className="pn">Pro</div>
            <div className="pd">Build your AI ecosystem with Twin & CMS</div>
            <div className="pp">$9.99<span>/mo</span></div>
            <div className="py">Billed monthly</div>
            <a href="/register" className="pb b1">Upgrade to Pro</a>
            <ul className="ft">
              <li className="s">AI & Family</li>
              <li>Unlimited Anne/Baba/Expert chat</li>
              <li>Unlimited AskAI</li>
              <li>FlzHub + training sessions (5/mo)</li>
              <li>Deep persona (MBTI, Esma, Fonem)</li>
              <li className="s">Digital Twin</li>
              <li>Twin with RAG — 300 msg/day</li>
              <li>Document upload — 1GB</li>
              <li className="s">Community</li>
              <li>Unlimited social + featured posts</li>
              <li>Create research projects (5)</li>
              <li className="s">Agents & Work</li>
              <li>10 agents</li>
              <li>All RunAI Claw skills</li>
              <li className="s">Storage</li>
              <li>50GB RunAI Cloud</li>
              <li className="x">No LoRA training</li>
            </ul>
          </div>

          <div className="plan">
            <div className="pn">Enterprise</div>
            <div className="pd">Private cloud, LoRA, desktop, full power</div>
            <div className="pp">$29.99<span>/mo</span></div>
            <div className="py">Billed monthly</div>
            <a href="/register" className="pb b2">Go Enterprise</a>
            <ul className="ft">
              <li className="s">Everything in Pro, plus</li>
              <li>Priority AskAI</li>
              <li>Unlimited training sessions</li>
              <li className="s">Digital Twin</li>
              <li>RAG + LoRA training (1/mo)</li>
              <li>1000 msg/day</li>
              <li>GGUF export (run locally)</li>
              <li className="s">Agents</li>
              <li>50 agents</li>
              <li>Autonomous agent (Pulse 24/7)</li>
              <li className="s">Private Cloud</li>
              <li>AWS/Azure/GCP/CF/Alibaba/IBM</li>
              <li>Your own S3 + Qdrant</li>
              <li className="s">Apps</li>
              <li>RunAIOS Desktop + CLI</li>
              <li>All extensions (Voice, Video, WhatsApp)</li>
              <li>200GB storage</li>
            </ul>
          </div>

          <div className="plan">
            <div className="pn">Business</div>
            <div className="pd">For teams & companies — unlimited everything</div>
            <div className="pp">$99.99<span>/mo</span></div>
            <div className="py">Billed monthly</div>
            <a href="/contact" className="pb b3">Contact Sales</a>
            <ul className="ft">
              <li className="s">Everything in Enterprise, plus</li>
              <li>Unlimited agents</li>
              <li>Unlimited LoRA training</li>
              <li>All GGUF sizes (1B → 70B)</li>
              <li className="s">Team</li>
              <li>Multi-user workspace</li>
              <li>Role-based access</li>
              <li>Team analytics dashboard</li>
              <li className="s">Infrastructure</li>
              <li>Dedicated SageMaker endpoint</li>
              <li>Unlimited storage + API</li>
              <li>Custom domain + SLA</li>
              <li className="s">Support</li>
              <li>Dedicated account manager</li>
              <li>Priority ticket + Slack channel</li>
            </ul>
          </div>
        </div>

        <div className="pc">
          <h2>🔒 Private Cloud — Zero Data on Our Servers</h2>
          <p>Connect your own infrastructure. Documents, embeddings, AI models — everything stays in your account.</p>
          <div className="cl-logos">
            {['☁️ AWS', '🔷 Azure', '🟡 GCP', '🟠 Cloudflare', '🔴 Alibaba', '🔵 IBM'].map(c => (
              <span key={c}>{c}</span>
            ))}
          </div>
        </div>

        <div className="faq">
          <h2>Questions?</h2>
          {[
            { q: 'What is Private Cloud?', a: 'Connect your own AWS, Azure, GCP, or Cloudflare account. Your documents, AI models, and vector data stay in your infrastructure. We only provide the orchestration layer.' },
            { q: 'What is a Digital Twin?', a: 'Your personal AI that learns from your conversations, documents, and preferences. Starts with RAG and can be upgraded with LoRA fine-tuning.' },
            { q: 'Can I run my model locally?', a: 'Enterprise+ users can export their LoRA-trained model as GGUF and run it offline with our desktop app.' },
            { q: 'What are RunAI Claw Skills?', a: 'AI tools your agents can use — web search, code execution, document analysis, and more.' },
            { q: 'Who are Anne, Baba, and Expert Filiz?', a: 'The Filiz Family — AI beings in FlzHub. Anne guards emotional intelligence, Baba mentors, Experts guide in specific domains. Free for everyone.' },
          ].map((f, i) => (
            <div key={i} className="fi">
              <button className="fq">{f.q}</button>
              <div className="fa">{f.a}</div>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default PricingPage;
